<template>
	<div
		v-if="!isFormClosed"
		class="row"
	>
		<div class="col-12 col-lg data-block">
			<!-- Выбор плательщика -->
			<div class="d-flex justify-content-center">
				<div class="payer-tabs mb-4">
					<b-button
						v-for="tab in tabs"
						:key="`$payer-tab-${tab.id}`"
						class="payer-tabs__button"
						:class="{ current: tab.value.includes(formValues.payer.type) }"
						:disabled="order.data?.id"
						@click="setPayerType(tab.id)"
					>
						{{ tab.text }}
					</b-button>
				</div>
			</div>
			<!-- Форма поступающего -->
			<div
				v-if="block.products.length > 1"
				class="mb-4"
			>
				<div class="title mb-4">
					Выбор потока программы
				</div>
				<products-component
					v-model="products"
					:block="block"
					@input="(value) => $emit('setSelectedProducts', value)"
				/>
			</div>

			<div class="title mb-4">
				1. Основная информация
			</div>
			<div v-if="block.enable_representative" class="row">
				<div class="mb-4 col-12">
					<FormulateInput
						v-model="formValues.is_representative"
						type="CustomSwitch"
						class="mb-3 small"
						name="is_representative"
						data-action="is_representative"
						label-text="Помогаю поступить"
					/>
				</div>
			</div>
			<div v-if="!autocompleted || loading" class="col-12 my-4 d-flex justify-content-center">
				<b-spinner variant="primary" />
			</div>
			<FormulateForm
				v-else
				v-model="formValues"
				class="form-step row"
				:class="{ disabled: order.data?.id }"
				:schema="schema"
				@onChangeSwitchMiddleName="onChangeSwitchMiddleName"
				@setCompanyInfo="setCompanyInfo"
				@validatePhone="validatePhone"
				@submit="submitHandler"
			>
				<!-- Форма представителя -->
				<div v-if="formValues.is_representative" class="mb-4 col-12 order-0">
					<div class="description strong mb-5">
						Данные представителя
					</div>
					<div class="row">
						<FormulateInput
							v-model="formValues.representative.first_name"
							type="text"
							label="Имя*"
							placeholder="Введите значение"
							validation-name="Имя"
							validation="required"
							class="col-12 col-md-12 col-lg-6"
							:validation-messages="{
								'required': 'укажите имя',
							}"
							@validation="nameErrors = $event.errors"
						/>
						<FormulateInput
							v-model="formValues.representative.last_name"
							type="text"
							label="Фамилия*"
							placeholder="Введите значение"
							class="col-12 col-md-12 col-lg-6"
							validation="required"
							validation-name="Фамилия"
							:validation-messages="{
								'required': 'укажите фамилию',
							}"
						/>
						<FormulateInput
							v-model="formValues.representative.phone"
							name="representative.phone"
							type="CustomPhoneInput"
							label="Телефон*"
							validation="required"
							:validation-messages="{
								'required': 'укажите телефон',
							}"
							placeholder="Введите значение"
							class="col-12 col-md-12 col-lg-6"
							inputmode="numeric"
						/>
						<FormulateInput
							v-model="formValues.representative.email"
							type="text"
							label="Эл. почта (не корпоративная)*"
							placeholder="Введите значение"
							class="col-12 col-md-12 col-lg-6"
							validation="bail|required|email"
							:validation-messages="{
								'required': 'укажите значение',
								'email': 'введите корректный e-mail',
							}"
						/>
					</div>
				</div>
				<div class="col-12 description strong mb-5 order-0">
					Данные обучающегося
				</div>
				<div
					v-if="!schema.length"
					class="col-12 mb-4"
				>
					<div class="border d-flex align-items-center justify-content-center h-100 p-4">
						<kind />
						<div class="title ml-3 text-left mb-0">
							Все необходимые данные заполнены, можно перейти к оплате
						</div>
					</div>
				</div>
				<div class="mb-4 col-12 order-5">

					<b-form-checkbox
						v-if="!$auth.user"
						v-model="noEducation"
						v-b-tooltip.hover
						tabindex="0"
						value="1"
						unchecked-value="0"
						class="mb-5 no-diplom"
						@change="(value) => $emit('changeNoEducationNonAuth', value)"
					>
						Нет диплома об образовании (стоимость обучения будет увеличена на 20% НДС)
					</b-form-checkbox>
				</div>

				<div v-if="!isPhysicalPayer" class="mb-4 col-12 order-5">
					<div class="description strong mb-5">
						Сведения о компании
					</div>
					<div class="row">
						<FormulateInput
							v-model="formValues.payer.name"
							type="CustomDadataCompany"
							class="col-12 col-md-12"
							label="Название*"
							:da-data-item="DaDataFullCompanyItem"
							:input_options="{placeholder: 'Введите значение'}"
							:validation="'required'"
							validation-name="company"
							:validation-messages="{
								'required': 'необходимо выбрать данные из справочника',
							}"
							@setCompanyInfo="(value) => fullCompanyPayer = value"
						/>
						<template v-if="!isIpPayer">
							<FormulateInput
								v-model="formValues.payer.email"
								type="text"
								class="col-12 col-md-12 col-lg-6"
								label="E-mail организации*"
								placeholder="Введите значение"
								validation-name="E-mail организации"
								:validation="'bail|required|email'"
								:validation-messages="{
									'required': 'обязательно к заполнению',
									'email': 'введите корректный e-mail',
								}"
							/>
							<FormulateInput
								v-model="formValues.payer.phone"
								type="CustomPhoneInput"
								class="col-12 col-md-12 col-lg-6"
								label="Рабочий телефон*"
								inputmode="numeric"
								placeholder="Введите значение"
								validation-name="Рабочий телефон"
								:validation="'required'"
								:validation-messages="{
									'required': 'обязательно к заполнению',
								}"
							/>
							<FormulateInput
								v-model="formValues.payer.edo_id"
								type="text"
								class="col-12"
								label="ID ЭДО / Идентификатор участника электронного документооборота"
								placeholder="Введите значение"
							/>
						</template>
					</div>
				</div>

				<div class="mb-4 col-12 order-5">

					<FormulateInput
						v-if="showPersonalData"
						class="mb-3 small"
						type="checkbox"
						validation="required"
						name="personalData"
						:validation-messages="{
							required: $t('agreementRequired')
						}"
						data-action="personalData"
					>
						<template #label="{ id }">
							<label :for="id" class="ml-2">
								Даю
								<a
									:href="`https://www.skolkovo.ru/static/personaldata_rus.html`"
									target="_blank"
								>
									согласие на обработку персональных данных
								</a>
							</label>
						</template>
					</FormulateInput>

					<advertising-mailings-input />

					<loyalty-registration-input />

					<b2b-alumni-input v-if="block.showb2bAlumniInput" />
				</div>
				<div class="col-12 order-7 d-flex flex-column justify-content-start">
					<slot name="footer" />
					<CookieError v-if="isErrorCookie" />
				</div>
			</FormulateForm>
		</div>
	</div>
</template>

<script>
import b2bAlumniInput from '~/components/panels/formulate/products/components/b2bAlumniInput.vue';
import PublicOfferAgreementInput from '~/components/panels/formulate/products/components/PublicOfferAgreementInput.vue';
import CookieError from '~/components/panels/formulate/products/components/CookieError.vue';
import Kind from '~/static/svg/kind.vue';
import ProductsComponent from '~/components/panels/formulate/products/ProductsComponent.vue';
import AdvertisingMailingsInput from '~/components/panels/formulate/products/components/AdvertisingMailingsInput.vue';
import LoyaltyRegistrationInput from '~/components/panels/formulate/products/components/LoyaltyRegistrationInput.vue';
import PointsWindow from '~/components/formulate/loyalty/PointsWindow.vue';
import formulateFormScenario from '~/mixins/formulateFormScenario';
import { FORM_PAYER_TYPE, LOYALTY_LEVELS } from '~/utils/dictionaries';
import DaDataFullCompanyItem from '~/components/daData/DadataItems/DaDataFullCompanyItem.vue';

import moment from '~/utils/moment';

const LEGAL_TYPES = {
	INDIVIDUAL: FORM_PAYER_TYPE.IP,
	LEGAL: FORM_PAYER_TYPE.URIDIC,
};

export default {
	name: 'FirstStep',
	components: {
		LoyaltyRegistrationInput,
		AdvertisingMailingsInput,
		ProductsComponent,
		Kind,
		CookieError,
		PublicOfferAgreementInput,
		b2bAlumniInput,
	},
	mixins: [formulateFormScenario],
	inject: ['person'],
	props: {
		block: { type: Object, required: true },
		order: { type: Object, default: () => ({}) },
		finalPrice: { type: Number, default: 0 },
		originalPrice: { type: Number, default: 0 },
		payerType: { type: Number, default: FORM_PAYER_TYPE.PHYSICAL },
	},
	data() {
		return {
			levels: LOYALTY_LEVELS,
			cardBackground: null,
			loyaltyData: null,
			fullCompanyPayer: null,
			loyaltyProfile: {},
			loading: true,
			noEducation: '0',
			tabs: [
				{
					id: FORM_PAYER_TYPE.PHYSICAL,
					value: [FORM_PAYER_TYPE.PHYSICAL],
					text: 'Физическое лицо',
				},
				{
					id: FORM_PAYER_TYPE.URIDIC,
					value: [FORM_PAYER_TYPE.URIDIC, FORM_PAYER_TYPE.IP],
					text: 'Юридическое лицо',
				},
			],
			DaDataFullCompanyItem,
		};
	},
	computed: {
		isPhysicalPayer() {
			return this.payerType === FORM_PAYER_TYPE.PHYSICAL;
		},
		isIpPayer() {
			return this.payerType === FORM_PAYER_TYPE.IP;
		},
		agreementsDocs() {
			const product = this.order?.data?.products[0];
			return product?.agreements;
		},
		agreementUridic() {
			const agr = this.agreementsDocs?.find((el) => el.type == 1 || el.type == 3);
			return agr?.file_url;
		},
	},
	watch: {
		payerType: {
			handler(type) {
				if (type) this.setPayerType(type);
			},
			immediate: true,
		},
		'formValues.is_representative': {
			async handler(data) {
				if (data && this.$auth.user) {
					const {
						first_name, last_name, email, phone,
					} = this.formValues;
					this.formValues.representative = {
						first_name, last_name, email, phone,
					};
					Object.assign(this.formValues, {
						first_name: null,
						last_name: null,
						email: null,
						phone: null,
						company_name: null,
						job_title: null,
						birthday: null,
					});
				}
			},
		},
		fullCompanyPayer(val) {
			if (val && val.value) {
				this.formValues.payer.name = val.value;
				if (val.data) {
					if (val.data.address) {
						this.formValues.payer.address = val.data.address.value;
						this.formValues.payer.index = val.data.address.data?.postal_code;
					}
					this.formValues.payer.inn = val.data.inn;
					this.formValues.payer.ogrn = val.data.ogrn;
					this.formValues.payer.kpp = val.data.kpp;
					this.formValues.payer.name = val.value;

					if (val.data.type) this.setPayerType(LEGAL_TYPES[val.data.type]);
				}
			}
		},
		'order.data': {
			handler() {
				if (!this.isPhysicalPayer) this.autocompletePayerForm();
			},
			immediate: true,
		},
		'person.personData': {
			handler() {
				if (this.isPhysicalPayer) this.loading = false;
			},
		},
	},
	async mounted() {
		await this.getLoyaltyProfile();
	},
	methods: {
		async updatePerson(hash, data, step) {
			try {
				await this.$api.syncPersonOnPayment(hash, data);
				const dynamicHash = this.$auth.user ? null : hash;
				this.$emit('submit', dynamicHash, step);
			} catch (e) {
				console.log(e);
			} finally {
				this.$emit('submitLoading', false);
			}
		},
		submitHandler(event, submit = false, step) {
			this.$emit('submitLoading', true);

			if (this.person.personData?.order_hash) {
				this.submit(this.person.personData?.order_hash, this.updatePerson, step);
				return;
			}

			this.submit();
		},
		setPayerType(id) {
			this.formValues.payer.type = id;
			this.$emit('changePayerType', id);
		},
		setLoyaltyData(val) {
			this.loyaltyData = val;
		},
		getData() {
			this.formValues.is_delayed_payment = +this.delayed_payment;

			if (!this.agreements.marketing_emails) {
				this.agreements.marketing_emails = !!this.formValues.advertisingMailingsAgreement;
			}
			if (!this.agreements.personal_data) {
				this.agreements.personal_data = !!this.formValues.personalData;
			}
			this.setAgreementFields();

			const noEducation = this.$auth.user ? {} : {
				noEducation: this.noEducation,
			};

			const userData = {
				sklTargetAction: this.block.form_scenario_action_label,
				sklBirthDate: this.formValues.birthday ? moment(this.formValues.birthday).format('DD.MM.YYYY') : '',
				advertisingMailingsAgreement: !!this.agreements.marketing_emails,
				sklAgreeSubscribeLookup: this.agreements.marketing_emails ? 'да' : 'нет',
				...this.formValues,
				...this.getAnalyticsData(),
				...{ can_return_vat_selected: +this.can_return_vat_selected },
				...noEducation,
			};

			const data = {
				products: this.selectedProducts ?? null,
				user_data: userData,
				entity_name: this.fetchedData.entity_name,
				entity_id: this.fetchedData.id,
				loyalty_data: this.loyaltyData,
			};

			return data;
		},
		async getLoyaltyProfile() {
			const { data } = await this.$api.getLoyaltyProfile();

			if (data) {
				this.loyaltyProfile = data;
				const [currentLevel] = this.levels?.filter((el) => el.id === this.loyaltyProfile.level.id);
				this.cardBackground = currentLevel.color;
			}
		},
		autocompletePayerForm() {
			if (this.$auth.user) {
				const { payer } = this.order.data.user_data;

				this.formValues.payer.phone = payer.phone;
				this.formValues.payer.email = payer.email;
				this.formValues.payer.edo_id = payer.edo_id;
				this.formValues.payer.name = payer.name;
				this.formValues.payer.kpp = payer.kpp;
			}

			this.loading = false;
		},
	},
};

</script>

<style lang="scss">
@import '~/assets/styles/sk_variables';
@import "~/assets/styles/bootstrap/scss/functions";
@import "~/assets/styles/bootstrap/scss/variables";
@import "~/assets/styles/bootstrap/scss/mixins";

.payer-tabs {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: .5rem;
	justify-content: space-between;
	background-color: $theme-light;
	border-radius: 3rem;
	padding: 0.5rem;

	&__button {
		color: $border-color;
		background-color: transparent;
		border-color: transparent;
		border-radius: 3rem;
		border: none;

		&:focus, &:active {
			border: none;
			box-shadow: none;
		}

		:hover {
			border-color: $border-color;
		}

		&.current {
			color: white;
			background-color: $blue;
			border-radius: 3rem;
		}

	}
	@include media-breakpoint-down(sm) {
		button {
			font-size: 0.8rem;
			font-weight: 500;
			padding: 0.375rem 0.45rem;
			border-radius: 3rem;
		}
	}

	.description {
		font-size: 1.2rem;
	}
}

.btn.btn-secondary:not(.disabled):hover {
	border-color: $border-color;
	color: #fff;
}

.form-step {
	&.disabled {
		.formulate-input-wrapper, .formulate-input-element, .formulate-input-element-decorator {
			pointer-events: none;
			opacity: 0.7;
		}
	}
}
</style>
